export default "__VITE_ASSET__Dnt8Iaq$__"